import(/* webpackMode: "eager" */ "C:\\wamp64\\www\\bloomfeeds\\src\\app\\about\\page.tsx");
